<script>
import MethodButtonBase from './MethodButtonBase';
import EparakstsMobileIcon from '../../assets/svg/eparaksts-mobile-square.svg';
export default {
  name: 'EparakstsMobileButton',
  components: {
    MethodButtonBase,
    EparakstsMobileIcon,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <EparakstsMobileIcon :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('eparaksts-mobile') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 28px;
  height: auto;
  margin-right: 8px;
}
</style>
